import React from 'react'

import { Header, ErrorHandler } from 'components'
import { Page } from 'common'
import { Routes } from 'common/constants'

import { useHome } from '../hooks/useHome'
import { useHomePrefetch } from '../hooks/useHomePrefetch'
import { HomeView } from './HomeView'
import { HomeSkeleton } from './HomeSkeleton'

export function Home() {
  useHomePrefetch()

  const {
    headerSection,
    errorOrInactive,
    isHomeLoading,
    menuSections,
    traceDetails,
    userCountry,
    babiButton,
    faqCard,
    helpCenterButton,
    supportCard,
    showServiceMenu,
  } = useHome()

  if (isHomeLoading) return <HomeSkeleton />

  if (errorOrInactive) {
    return <ErrorHandler traceDetails={traceDetails} componentName={Home.name} />
  }

  return (
    <Page>
      {headerSection?.isActive && (
        <Header title={headerSection.title} goToPath={Routes.ENTITY} isHome />
      )}
      <HomeView
        menuSections={menuSections}
        userCountry={userCountry}
        babiButton={babiButton}
        faqCard={faqCard}
        helpCenterButton={helpCenterButton}
        supportCard={supportCard}
        showServiceMenu={showServiceMenu}
      />
    </Page>
  )
}
